// extracted by mini-css-extract-plugin
export var banner = "_r9-0";
export var settingRow = "_r9-2";
export var titleIcon = "_r9-1";